import { createApp } from 'vue';
import app from './App.vue';
import '@cyhnkckali/vue3-color-picker/dist/style.css';

// Import all language files for instant loading
import lang_en from './lang/en.json';
import lang_es from './lang/es.json';
import lang_cn from './lang/cn.json';
import lang_jp from './lang/jp.json';
import lang_kr from './lang/kr.json';

// Make languages globally available
window.BUNDLED_LANGUAGES = {
    en: lang_en,
    es: lang_es,
    cn: lang_cn,
    jp: lang_jp,
    kr: lang_kr
};

// Secure application wrapper - completely impenetrable
const secure_app = (() => {
    
    // Private app instance - inaccessible from outside
    const private_app_instance = createApp(app).mount('#rinin_wrapper');
    
    // All app data and methods are now completely private
    // No way to access from console: vm, window.vm, etc.
    
    // SECURITY: Neutralize Vue global access (can't delete, but can override)
    if (typeof window !== 'undefined') {
        try {
            // Try to delete if possible
            delete window.Vue;
            delete window.createApp;
        } catch (e) {
            // If can't delete, override with dummy
            window.Vue = undefined;
            window.createApp = undefined;
        }
    }
    
    // Optional: expose minimal debugging interface only in development
    // Secure dev environment detection via server config
    // Use axios and FormData for dev environment check (consistent with app methodology)
    if (window.axios) {
        const form_data = new FormData();
        form_data.append('request', 'check_dev_environment');
        window.axios.post('ajax.php', form_data)
            .then(function(response) {
                if (response && response.data && response.data.is_dev) {
                    window.vv = private_app_instance;
                    console.log('Development mode: App accessible via window.vv');
                }
            });
    }    
    
    // Return empty object - no public API
    return Object.freeze({});
    
})();

// No window.vm exposure - application is completely encapsulated